module.exports = __webpack_public_path__ + "static/media/GA-2100BWP-2AER_OR09_Bandview.896d552e.jpg";